import React from 'react'
import Accordion from '../../Accordion/Accordion'
import AccordionChild from '../../AccordionChild/AccordionChild'
import { Center } from '@/types/models'

interface Props {
  data: Center
  offersDetox: boolean
  detoxServiceIndex: number
}

const DefaultCenterFAQs: React.FC<Props> = ({
  data,
  offersDetox,
  detoxServiceIndex
}) => {
  return (
    <>
      <Accordion>
        {!!data.pricing_label?.trim() && (
          <AccordionChild heading={`How much does ${data.title} cost?`}>
            While costs may vary due to program length and insurance benefits,
            it typically costs {data.pricing_label?.trim()}.
          </AccordionChild>
        )}
        {!!data.location_label?.trim() && (
          <AccordionChild heading={`Where is ${data.title} located?`}>
            {data.location_label?.trim()}.
          </AccordionChild>
        )}
        {!!data.insurance_description?.trim() && (
          <AccordionChild heading={`What insurance does ${data.title} accept?`}>
            {data.insurance_description?.trim()}.
          </AccordionChild>
        )}
        {!!data.length_label?.trim() && (
          <AccordionChild heading="How long is treatment?">
            The typical length is {data.length_label?.trim()}.
          </AccordionChild>
        )}
        {offersDetox && (
          <AccordionChild heading={`Does ${data.title} offer detox?`}>
            Yes, services include{' '}
            {data.treatment_services[detoxServiceIndex]?.toLowerCase()}.
          </AccordionChild>
        )}
      </Accordion>
    </>
  )
}

export default DefaultCenterFAQs
